import { useUserStore } from '@/stores/user'

export const roleMiddleware = (to, from, next) => {
    const { authorize } = to.meta
    const store = useUserStore()

    // Match authorized roles with user roles
    const userAuthorized = authorize?.filter((role) => store.roles.includes(role)).length > 0

    if (authorize?.length && !userAuthorized) {
        return next({ path: '/404' })
    }

    next()
}
